// import { ElInfiniteScroll } from '@map-sdk/components/infinite-scroll'
// import { ElLoading } from '@map-sdk/components/loading'
// import { ElMessage } from '@map-sdk/components/message'
// import { ElMessageBox } from '@map-sdk/components/message-box'
// import { ElNotification } from '@map-sdk/components/notification'
// import { ElPopoverDirective } from '@map-sdk/components/popover'

import type { Plugin } from 'vue'

export default [] as Plugin[]
